export enum FieldType {
  STRING = 'string',
  MULTILINE = 'multiline',
  NUMBER = 'number',
  DATE = 'date',
  DATETIME = 'datetime',
  TIME = 'time',
  AUTOCOMPLETE = 'autocomplete',
  MULTISELECT = 'multiselect',
  CHECKBOX = 'checkbox',
}

export type TemplateField = {
  label: string;
  type: FieldType;
  options?: string[];
  uuid: string;
};

export type Field = TemplateField & {
  value: string | number | string[] | null;
};

export type FieldOption = {
  label: string;
  value: FieldType;
};
